// @flow
export const DEFAULT = "0[.]0";
export const SHORT_PRICE = "$0a";
export const DEC_PRICE = "$0[.]0a";
export const TWO_DEC_PRICE = "$0[.]00a";
export const PERCENTAGE = "0%";
export const PCT_DIFF = "+0[.]0%";